import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Mail } from "lucide-react";
const Contact = () => {
  return <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <Link to="/">
            <Button variant="ghost" className="mb-6">← Back to Home</Button>
          </Link>
          
          <h1 className="text-3xl font-bold mb-8">Contact Us</h1>
          
          <div className="space-y-6 text-film-600">
            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Get in Touch</h2>
              <p>Have questions, suggestions, or want to share your experiences with The Safelight Project? We'd love to hear from you!</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Email Us</h2>
              <div className="flex items-center gap-2 mt-2">
                <Mail className="h-5 w-5 text-muted-foreground" />
                <a href="mailto:safelightproject@gmail.com" className="text-primary hover:underline transition-colors">
                  safelightproject@gmail.com
                </a>
              </div>
              <p className="mt-3">We aim to respond to all inquiries within 48 hours during the business week.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Community</h2>
              <p>
                Join our community of film photographers around the world. Share your experiences, 
                contribute reviews, and help make travel with film easier for everyone.
              </p>
              <div className="mt-4">
                <Link to="/resources">
                  <Button>Explore Resources</Button>
                </Link>
              </div>
            </section>

            <section>
              
              
              <div className="mt-4">
                <Link to="/new-review">
                  
                </Link>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>;
};
export default Contact;